import React from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, Briefcase, Trophy, MessageSquare, Settings, Layers, Building2, Construction, ShieldCheck } from "lucide-react";

export function Placeholder({ icon: Icon, title, subtitle }) {
  return (
    <div className="flex min-h-[55vh] flex-col items-center justify-center px-8 text-center">
      <span className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-medorange-light text-medorange">
        <Icon className="h-7 w-7" />
      </span>
      <h1 className="font-heading text-xl font-extrabold text-slate-900">{title}</h1>
      <p className="mt-2 max-w-xs text-sm text-slate-500">{subtitle}</p>
      <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-500">
        <Construction className="h-3.5 w-3.5" /> Coming in Phase 2
      </span>
    </div>
  );
}

export function Achievements() { return <Placeholder icon={Trophy} title="Achievements" subtitle="Celebrate milestones and recognitions from Ahmedabad's healthcare network." />; }
export function Messages() { return <Placeholder icon={MessageSquare} title="Messages" subtitle="Direct messaging between professionals — arriving in Phase 3." />; }
export function SettingsPage() { return <Placeholder icon={Settings} title="Settings" subtitle="Manage your profile, notifications and preferences." />; }

export function More() {
  const navigate = useNavigate();
  const items = [
    { label: "Get Verified", icon: ShieldCheck, to: "/verify-professional" },
    { label: "Govt & Health", icon: Building2, to: "/govt-health" },
    { label: "Communities", icon: Layers, to: "/communities" },
    { label: "Events", icon: Calendar, to: "/events" },
    { label: "Marketplace", icon: Briefcase, to: "/opportunities" },
    { label: "Achievements", icon: Trophy, to: "/achievements" },
    { label: "Saved", icon: MessageSquare, to: "/saved" },
    { label: "Settings", icon: Settings, to: "/settings" },
  ];
  return (
    <div className="px-4 py-4 pb-8">
      <h1 className="mb-4 font-heading text-xl font-extrabold text-slate-900">More</h1>
      <div className="grid grid-cols-2 gap-3">
        {items.map((it) => (
          <button key={it.to} onClick={() => navigate(it.to)}
            className="flex flex-col items-start gap-3 rounded-2xl border border-slate-200 bg-white p-4 text-left transition-colors hover:border-medorange/50">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-white"><it.icon className="h-5 w-5" /></span>
            <span className="font-heading text-sm font-bold text-slate-900">{it.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
